// En Chatsell, WhatsApp QR, Instagram, Messenger y TikTok son todos
// Channel::Api: el channel_type no alcanza para saber por dónde habla el
// cliente. Lo que los distingue es a qué servicio apunta el webhook_url.
export const API_CHANNEL_KINDS = {
  WHATSAPP_QR: 'whatsapp_qr',
  INSTAGRAM: 'instagram',
  MESSENGER: 'messenger',
  TIKTOK: 'tiktok',
};

const API_CHANNEL_WEBHOOK_PATHS = [
  // chatsell-wpp (pkg/chatwoot/client.go)
  ['/api/webhook/chatwoot', API_CHANNEL_KINDS.WHATSAPP_QR],
  // chatsell-webhook-meta (webhook/*_routes.py)
  ['/api/instagram/chatwoot-webhook', API_CHANNEL_KINDS.INSTAGRAM],
  ['/api/messenger/chatwoot-webhook', API_CHANNEL_KINDS.MESSENGER],
  ['/api/tiktok/chatwoot-webhook', API_CHANNEL_KINDS.TIKTOK],
];

export const getApiChannelKind = (webhookUrl = '') => {
  const url = webhookUrl || '';
  const match = API_CHANNEL_WEBHOOK_PATHS.find(([path]) => url.includes(path));
  return match ? match[1] : null;
};

// Canales de Meta con ventana de 24 h desde el último mensaje del cliente.
// webhook-meta envía sin message tag (sender.py), así que no aplica la
// extensión de 7 días de HUMAN_AGENT.
export const isMetaApiChannel = webhookUrl =>
  [API_CHANNEL_KINDS.INSTAGRAM, API_CHANNEL_KINDS.MESSENGER].includes(
    getApiChannelKind(webhookUrl)
  );

export const API_CHANNEL_ICONS = {
  [API_CHANNEL_KINDS.WHATSAPP_QR]: 'brand-whatsapp',
  [API_CHANNEL_KINDS.INSTAGRAM]: 'brand-instagram',
  [API_CHANNEL_KINDS.MESSENGER]: 'brand-facebook',
};

// Clave de badge de Thumbnail.vue (public/integrations/channels/badges).
const API_CHANNEL_BADGES = {
  [API_CHANNEL_KINDS.WHATSAPP_QR]: 'whatsapp',
  [API_CHANNEL_KINDS.INSTAGRAM]: 'instagram_direct_message',
  [API_CHANNEL_KINDS.MESSENGER]: 'facebook',
};

export const getApiChannelBadge = webhookUrl =>
  API_CHANNEL_BADGES[getApiChannelKind(webhookUrl)] || '';
